import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useDisclosure,
  Text,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTaxes } from "../../../contexts/TaxV2Context";
import { ExclamationCircleIcon } from "../../../styles/icons/ExclamationCircleIcon";

export function AddBrandModal({ setOrganizedRates, tabStatus, organizedRates, onEdit }) {
  const { brands } = useTaxes();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectBrand, setSelectBrand] = useState<string | null>(null);



  if (!organizedRates || typeof organizedRates !== "object") {
    console.error("Erro crítico: organizedRates não é um objeto válido.", organizedRates);
    return null;
  }

  const availableBrandsMock = brands?.map((item) => item?.brandCard) || [];

  const handleAddBrand = () => {
    if (!selectBrand) {
      console.error("Erro: Nenhuma bandeira foi selecionada.");
      return;
    }
  
  
    const fullBrand = brands.find((item) => item.brandCard === selectBrand);
    if (!fullBrand) {
      console.error("Erro: Bandeira não encontrada nos dados de brands.");
      return;
    }
  
    setOrganizedRates((prevRates) => {
      const updatedRates = { ...prevRates };
  
      if (!updatedRates[tabStatus]) {
        updatedRates[tabStatus] = [];
      }
  

      const defaultBrand = updatedRates[tabStatus].find((item) => item.paymentBrandModel === null);
  
      if (!defaultBrand) {
        console.error(`Erro: Nenhuma bandeira padrão encontrada para ${tabStatus}`);
        return prevRates;
      }
  
  
      const clonedBrand = {
        ...defaultBrand,
        paymentBrandModel: fullBrand, 
        rates: defaultBrand.rates.map((rate) => ({ ...rate })),
      };
  
      updatedRates[tabStatus] = [...updatedRates[tabStatus], clonedBrand];
  
      return updatedRates;
    });
  
    setSelectBrand(null);
  };
  
  
  return (
    <>
      <Flex alignItems="center" gap="8px">
        <Button onClick={onOpen} variant="outline" h="32px" w="177px" p="5px 16px" cursor="pointer" disabled={!onEdit}>
          <Text fontSize="14px"  color="#000000" fontWeight="400" >+ Adicionar bandeira</Text>
        </Button>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <Flex flexDirection="row" alignItems="flex-start" gap="16px" p="32px 24px 0 24px">
            <ExclamationCircleIcon />
            <Flex flexDirection="column" flex="1">
              <ModalHeader fontSize="18px" lineHeight="22px" p="0">
                Para criar taxas específicas para uma bandeira, selecione abaixo a bandeira a ser adicionada
              </ModalHeader>
              <ModalBody p="0">
                <Menu>
                  <MenuButton
                    as={Button}
                    w="177px"
                    h="32px"
                    fontSize="14px"
                    lineHeight="22px"
                    fontWeight="400"
                    backgroundColor="white"
                    border="1px solid rgba(217, 217, 217, 1)"
                    p="5px 16px"
                  >
                    {selectBrand ? selectBrand : "+ Adicionar bandeira"}
                  </MenuButton>
                  <MenuList sx={{ width: "177px", minWidth: "auto" }}>
                    {availableBrandsMock?.filter(
                      (brand) =>
                        !organizedRates[tabStatus]?.some(
                          (item) => item?.paymentBrandModel?.brandCard?.toUpperCase() === brand
                        )
                    ).length === 0 ? (
                      <MenuItem isDisabled key="empty">Vazio</MenuItem>
                    ) : (
                      availableBrandsMock
                        ?.filter(
                          (brand) =>
                            !organizedRates[tabStatus]?.some(
                              (item) => item?.paymentBrandModel?.brandCard?.toUpperCase() === brand
                            )
                        )
                        ?.map((brand) => (
                          <MenuItem
                            key={brand}
                            onClick={() => setSelectBrand(brand)}
                            sx={{ width: "177px", minWidth: "auto" }}
                          >
                            {brand?.charAt(0)?.toUpperCase() + brand?.slice(1)}
                          </MenuItem>
                        ))
                    )}
                  </MenuList>
                </Menu>
              </ModalBody>
            </Flex>
          </Flex>

          <ModalFooter gap="12px" p="24px">
            <Button variant="outline" onClick={onClose} h="32px">Cancelar</Button>
            <Button colorScheme="blue" onClick={handleAddBrand} h="32px">Criar bandeira</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
